import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-input-discount-dialog',
  templateUrl: './input-discount-dialog.component.html',
  styleUrls: ['./input-discount-dialog.component.css']
})
export class InputDiscountDialogComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private formBuilder: FormBuilder,
  ) { }

  @Input() itemCateName: string;
  @Input() itemDesc: string;
  @Input() PTypeDesc: string;
  @Input() standardPrice: number;
  editForm: FormGroup;

  submitted = false;

  discountRate = 0;

  ngOnInit() {
    this.log.i('Dialog', 'input_Dialog_Model action = ' + this.itemCateName + ',' + this.itemDesc + ',' + this.PTypeDesc);
  
    this.editForm = this.formBuilder.group({

      itemCateName: [this.itemCateName],
      itemDesc: [this.itemDesc],
      PTypeDesc: [this.PTypeDesc],
      discountRate: [this.discountRate, Validators.required],
      standardPrice:[this.standardPrice],
      priceAfterDiscount:[]

    });
  }

  get f() { return this.editForm.controls; }
  calDiscount(){
    var afterValue=this.editForm.get('priceAfterDiscount').value;
    this.editForm.get('discountRate').setValue((afterValue/this.standardPrice).toFixed(6));
  }
  changeDiscount(){
    var discount=this.editForm.get('discountRate').value;
    this.editForm.get('priceAfterDiscount').setValue((discount*this.standardPrice).toFixed(1));
  }
  confirm() {

    this.submitted = true;

    if (this.editForm.valid) {

      this.discountRate = this.editForm.get('discountRate').value;

      this.activeModal.close(this.discountRate);
    }

    
  }

  cancel() {
    this.activeModal.dismiss('OK');
  }

}
